module.exports = __webpack_public_path__ + "img/cn.7f8455b7.svg";